const nestedApiResource = (obj: any) => (prop: any) => {
	const toReturn = prop.split('.').reduce((o: any, p: any) => o && o[p], obj, [])
	return toReturn
}
type PaginatedState = {
	items: any[]
	loading: boolean
	error: any
	page: number
	pageSize: number
	nextPage: any
}

export const generatePaginatedStore = ({ pageSize, apiResource }: any) => {
	const state: PaginatedState = {
		items: [],
		loading: false,
		error: null,
		page: 1,
		pageSize: 25,
		nextPage: null
	}

	const getters = {
		hasItems: (state: any) => state.items.length > 0,
		hasNext: (state: any) => !!state.nextPage
	}
	const actions = {
		/**
		 * Creates an paginated getter from the API with the given API resource, and params
		 *
		 * @param {Object} params - Params to be used in the request query
		 * @param {Object} query - Query to be used in the request query
		 * @throws {Error} - API request error
		 */
		async list(params: any, query?: any) {
			// TODO: Help, dunno how to fix these
			try {
				if (params && params.page) {
					// @ts-ignore
					this.page = params.page
				}
				// @ts-ignore
				this.loading = true
				const { $singaApi } = useNuxtApp()
				// @ts-ignore
				const { data } = await nestedApiResource($singaApi)(apiResource).list({ page_size: pageSize, page: this.page, ...params, ...query })
				if (data.value) {
				// @ts-ignore
					this.loading = false
					// @ts-ignore
					this.nextPage = data.value.next
					// @ts-ignore
					this.items = params && params.page ? [...data.value.results] : [...this.items, ...data.value.results]
					// @ts-ignore
					this.count = data.value.count
					// @ts-ignore
					this.page++
				}
			} catch (error) {
				// @ts-ignore
				this.loading = false
				// @ts-ignore
				this.error = error.response
			}
		}
	}
	return {
		state, getters, actions
	}
}
